<template>
    <div class="GridBox" :style="GridStyle">
        <div v-for="(item, index) in gridDatas.data"
          :class="getBoolean(index) ? 'cursorClass' : '' "
          :style="{
              ...BoxStyle,
              ...(gridDatas.settings && gridDatas.settings[index])
          }"
          :key="index"
          @click="fn(index)"
        >
          <slot name="default" :data="{item, index}"></slot>
          {{item}}
        </div>
    </div>
</template>
<script>
export default {
    name: 'Grid',
    methods: {
      getBoolean(index){
        let flag = false
        if(Object.keys(this.indexObj).length){
          for(let i = 0, arr = this.indexObj.arr;i < arr.length; i++){
            if((index - arr[i]) % this.indexObj.start == 0 && index > this.indexObj.start && index < this.gridDatas.data.length - this.indexObj.start){
              flag = true
              break;
            }
          }
        }
        return flag
      }
    },
    props:{
        fn: {
          type: Function,
          default(){}
        },
        indexObj: {
          type: Object,
          default(){
            return new Object
          }
        },
        GridStyle:{
            type: Object,
            default: () => {
                return {
                    'grid-template-columns': 'repeat(3, 33%)',
                    'grid-template-rows': 'repeat(4, 24%)',
                    'font-size': '0.14rem'
                }
            }
        },
        gridDatas: Object,
        BoxStyle: Object,
    }
}
</script>
<style lang="less" scoped>
    .GridBox{
      word-break: break-all;
      text-align: center;
      border: 1px solid #fff;
      height: 100%;
      z-index: 2;
      position: relative;
      font-size: 0.18rem;
      color: #ffffff;
      display: grid;
      background: #fff;
      row-gap: 0.01rem; //行间距
      column-gap: 0.01rem; //列间距
      justify-content: space-between;
      align-content: space-between;
      overflow: auto;
      &::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 3px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 5px;
        display: none;
      }
      &::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 10px;
        background-color: #272525;
        background-image: -webkit-linear-gradient(
          45deg,
          rgba(255, 255, 255, 0.2) 25%,
          transparent 25%,
          transparent 50%,
          rgba(255, 255, 255, 0.2) 50%,
          rgba(255, 255, 255, 0.2) 75%,
          transparent 75%,
          transparent 100%
        );
      }
      &::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: #ededed;
        border-radius: 10px;
      }
      div{
          background: #000a3b;
          display: flex;
          align-items: center;
          justify-content: center;
      }
      .cursorClass{
        cursor: pointer;
        &:hover{
          background: rgb(2, 217, 253);
        }
      }
    }
</style>